import { render, staticRenderFns } from "./skor_presensi.vue?vue&type=template&id=6baabcef"
import script from "./skor_presensi.vue?vue&type=script&lang=js"
export * from "./skor_presensi.vue?vue&type=script&lang=js"
import style0 from "./skor_presensi.vue?vue&type=style&index=0&id=6baabcef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports